/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Tooltip_SourceInputs */

const id_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

const ms_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

const da_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilde`)
};

const de_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle`)
};

const en_us2_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const es_es2_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

const es_mx2_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

const fil_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinagmulan`)
};

const fr_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const it_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const hu_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrás`)
};

const nl_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bron`)
};

const no_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilde`)
};

const pl_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Źródło`)
};

const pt_br2_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const pt_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const ro_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sursă`)
};

const fi_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähde`)
};

const sv_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Källa`)
};

const vi_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nguồn`)
};

const tr_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaynak`)
};

const cs_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj`)
};

const bg_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Източник`)
};

const ru_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источник`)
};

const uk_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Джерело`)
};

const ar_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصدر`)
};

const hi_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत`)
};

const th_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แหล่งที่มา`)
};

const ja_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース`)
};

const zh_cn2_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源`)
};

const zh_hant1_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`來源`)
};

const ko_builds_tooltip_source = /** @type {(inputs: Builds_Tooltip_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출처`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Builds_Tooltip_SourceInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_tooltip_source = /** @type {((inputs?: Builds_Tooltip_SourceInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Tooltip_SourceInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_tooltip_source(inputs)
	if (locale === "ms") return ms_builds_tooltip_source(inputs)
	if (locale === "da") return da_builds_tooltip_source(inputs)
	if (locale === "de") return de_builds_tooltip_source(inputs)
	if (locale === "en-US") return en_us2_builds_tooltip_source(inputs)
	if (locale === "es-ES") return es_es2_builds_tooltip_source(inputs)
	if (locale === "es-MX") return es_mx2_builds_tooltip_source(inputs)
	if (locale === "fil") return fil_builds_tooltip_source(inputs)
	if (locale === "fr") return fr_builds_tooltip_source(inputs)
	if (locale === "it") return it_builds_tooltip_source(inputs)
	if (locale === "hu") return hu_builds_tooltip_source(inputs)
	if (locale === "nl") return nl_builds_tooltip_source(inputs)
	if (locale === "no") return no_builds_tooltip_source(inputs)
	if (locale === "pl") return pl_builds_tooltip_source(inputs)
	if (locale === "pt-BR") return pt_br2_builds_tooltip_source(inputs)
	if (locale === "pt") return pt_builds_tooltip_source(inputs)
	if (locale === "ro") return ro_builds_tooltip_source(inputs)
	if (locale === "fi") return fi_builds_tooltip_source(inputs)
	if (locale === "sv") return sv_builds_tooltip_source(inputs)
	if (locale === "vi") return vi_builds_tooltip_source(inputs)
	if (locale === "tr") return tr_builds_tooltip_source(inputs)
	if (locale === "cs") return cs_builds_tooltip_source(inputs)
	if (locale === "bg") return bg_builds_tooltip_source(inputs)
	if (locale === "ru") return ru_builds_tooltip_source(inputs)
	if (locale === "uk") return uk_builds_tooltip_source(inputs)
	if (locale === "ar") return ar_builds_tooltip_source(inputs)
	if (locale === "hi") return hi_builds_tooltip_source(inputs)
	if (locale === "th") return th_builds_tooltip_source(inputs)
	if (locale === "ja") return ja_builds_tooltip_source(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_tooltip_source(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_tooltip_source(inputs)
	return ko_builds_tooltip_source(inputs)
});
export { builds_tooltip_source as "builds.tooltip.source" }